/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import React from 'react'
import { Tooltip } from 'antd'
import { SwitchInput } from '../../ts-components/SwitchInput'
import { FormAction } from '../reducer/useFeedPostReducer'
import GroupedRoleSelector from './GroupedRoleSelector'

interface PostSettingsProps {
  activeCompetition: boolean
  dispatch: React.Dispatch<FormAction>
  isSelectedTypeOrg: boolean
  hasUpdateOrAdminPermission: boolean
  hasAudience: boolean
  visibleToRoles: string[]
  fieldErrors: string[]
  customError: { [key: string]: string }
}

// Role types configuration — kept for backward compat
export const ROLE_TYPES = [
  { id: '0', name: 'Owner' },
  { id: '1', name: 'Admin' },
  { id: '2', name: 'League Manager' },
  { id: '3', name: 'Referee' },
  { id: '4', name: 'Scorekeeper' },
  { id: '5', name: 'Videographer' },
  { id: '6', name: 'Player' },
  { id: '7', name: 'Team Official' },
  { id: '8', name: 'Timekeeper' },
  { id: '9', name: 'Followers' },
]

/**
 * PostSettings component - handles post configuration settings
 */
export const PostSettings: React.FC<PostSettingsProps> = ({
  activeCompetition,
  dispatch,
  isSelectedTypeOrg,
  hasUpdateOrAdminPermission,
  hasAudience,
  visibleToRoles,
  fieldErrors,
  customError,
}) => {
  return (
    <>
      {/* Target Audience selector */}
      <Tooltip title={!hasAudience ? 'Select an audience first' : ''}>
        <div
          css={css`
            display: flex;
            flex-direction: column;
            gap: 8px;
            margin-bottom: 16px;
            ${!hasAudience ? 'opacity: 0.4; pointer-events: none;' : ''}
          `}
        >
          <GroupedRoleSelector
            value={visibleToRoles}
            onChange={(value) =>
              dispatch({
                type: 'SET_FIELD',
                field: 'visibleToRoles',
                payload: value,
              })
            }
            fieldErrors={fieldErrors}
            customError={customError}
            name='visibleToRoles'
          />
        </div>
      </Tooltip>

      {/* Target Active Competitions - Only show for orgs with permissions */}
      {isSelectedTypeOrg && hasUpdateOrAdminPermission && (
        <div
          css={css`
            display: flex;
            align-items: center;
            gap: 8px;
            align-self: stretch;
            width: 100%;
            margin-bottom: 16px;
          `}
        >
          <SwitchInput
            title='Target Active Competitions'
            subtitle='Only send to users in currently active competitions'
            value={activeCompetition}
            onChange={(value) =>
              dispatch({
                type: 'SET_FIELD',
                field: 'activeCompetition',
                payload: value,
              })
            }
          />
        </div>
      )}
    </>
  )
}
